import { render, staticRenderFns } from "./detail-content.vue?vue&type=template&id=f65d81da&scoped=true"
import script from "./detail-content.vue?vue&type=script&lang=js"
export * from "./detail-content.vue?vue&type=script&lang=js"
import style0 from "./detail-content.vue?vue&type=style&index=0&id=f65d81da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65d81da",
  null
  
)

export default component.exports